import { BackIcon } from '@components/icons/BackIcon';
import { useLocationPathname } from 'context/LocationProvider/LocationProvider';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface BackButtonProps {
  navigateTo: string;
}

const BackButton: FC<BackButtonProps> = ({ navigateTo }) => {
  const navigate = useNavigate();
  const { getPreviousPageLocation } = useLocationPathname();

  const { t } = useTranslation();

  const handleOnClick = (): void => {
    const previousPage = getPreviousPageLocation();

    // Check if there's a previous page and it's from our website
    if (previousPage && window.history.length > 1) {
      navigate(-1);
    } else {
      // Navigate to the specified route if no previous page
      navigate(navigateTo);
    }
  };

  return (
    <div
      className="flex items-center gap-2 font-bold text-primary text-base cursor-pointer w-min"
      onClick={handleOnClick}
    >
      <BackIcon />
      <p>{t('common.buttons.back')}</p>
    </div>
  );
};
export default BackButton;
